import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { Container, Typography } from "@mui/material";
import Layout from "../../components/common/Layout";
import { ThinUnderlineText } from "../../components/common/StyledComponents";

export default function PrivacyPolicy() {
  const { t } = useTranslation(["common"]);

  return (
    <Layout>
      <Container sx={{ marginTop: "20vh", marginBottom: "5vh" }}>
        <Typography variant="h3">{t("privacy_policy")}</Typography>

        <Typography
          fontFamily={"Inter"}
          variant="h6"
          mt={6}
          className="lineBreak"
        >
          This privacy policy governs the collection, use, processing,
          protection, storage and the privacy of any Personal Information
          provided to us, or otherwise collected by us, offline or online,
          including through our website and mobile application.
          {"\n"}
          {"\n"}1. DEFINITIONS
          {"\n"}
          As used under this Privacy Policy, the terms:
          {"\n"}
          1.1 “Naturethings”, “we”, “us” or “our” refers to All Nature Things
          Pte Ltd of UEN 202113379K at 1 North Bridge Road, #12-09, High Street
          Center, Singapore, 179094.
          {"\n"}
          1.2 “Platform” means Platform and website, including any subdomains
          thereof, mobile apps, and any other websites and apps through which
          Naturethings makes its services available (collectively).
          {"\n"}
          1.3 “Personal Information” refers to any data, information, or
          combination of data and information that is provided by you to us, or
          through your use of our products or services, that relates to an
          identifiable individual.
          {"\n"}
          {"\n"}2. WHAT INFORMATION WE COLLECT ABOUT YOU
          {"\n"}
          2.1 We collect the following types of information about you:
          {"\n"}
          (a) account and profile information that you provide when you register
          for an account or sign up for our products or services, for example
          your name, username or similar identifier, other personal description,
          professional title, physical and digital billing address, email
          address, telephone number(s), company registered name, company website
          and contact details, preferred mode of payment, original work product
          details, nature of your business and the number of employees in your
          company (collectively, “Account Data”).
          {"\n"}
          (b) information you provide through support channels, for example when
          you report a problem to us or interact with our support team,
          including any contact information, documentation, or screenshots
          (collectively, “Support Data”).
          {"\n"}
          (c) content you provide through use of our products or services, for
          example naturethings content channels on platform: We have public
          blogs, digital articles on our platform. Any information you provide
          in these areas may be read, collected, and used by anyone.
          {"\n"}
          2.2 If your Personal Information appears on our platform and if you
          would like to remove it, you can send your request to
          eva@naturethings.co. In some cases, we may not be able to remove your
          Personal Information, in which case we will let you know if we are
          unable to do so and why.
          {"\n"}
          2.3 Third Parties: We are not responsible, and this Privacy Policy
          does not cover your use of any third-party widgets, features, or
          websites or links to third-party websites or services. We encourage
          you to read the privacy policy of any third-party site you visit or
          service you use carefully. We publish customer testimonials on our
          website, which may contain Personal Information. We obtain consent to
          post the customer’s name along with their testimonial.
          {"\n"}
          2.4 Removal: To request the removal of your Personal Information from
          a testimonial, please email us at eva@naturethings.co.
          {"\n"}
          2.5 Social Media Widgets: Our Websites include social media features.
          These features may collect your IP address, which page(s) you are
          visiting, and may set cookies to make sure they function properly.
          Social media features and widgets are either hosted by a third party
          or hosted directly on our site. Your interactions with those features
          are governed by the privacy policy of the companies providing them
          (collectively, “User Content”); Communication, marketing, and other
          preferences that you set when you set up your account or profile, or
          when you participate in a survey or a questionnaire that we send you
          (collectively, “Preference Data”); Details of any transactions,
          purchases, or orders that you have made with us (collectively,
          “Transaction Data”); Payment information, for example Your payment
          card information or bank account details (collectively, “Financial
          Data”); Information about your device or connection, for example your
          internet protocol (IP) address, log-in data, browser type and version,
          time-zone setting, browser plug-in types and versions, operating
          system and platform, and other technology on the devices you use to
          access our products or services and information we collect through
          cookies and other data collection technologies (please read our
          Cookies Policy for details) (collectively, “Technical Data”); and
          Information about your use of or visit to our Platform, for example
          your clickstream to, through, and from our Platform, products you
          viewed, used, or searched for, page response times, download errors,
          length of visits to certain pages, page interaction information (such
          as scrolling, clicks, and mouse-overs), or methods to browse away from
          the page (collectively, “Usage Data”).
          {"\n"}
          2.6 We collect the above information when you provide it to us or when
          you use or visit our Platform. We may also receive information about
          you from other sources, including: our current and future personnel,
          agents, advisors, consultants, and contractors based in various
          jurisdictions, including in particular, Singapore, India, Philippines,
          and Indonesia in connection with our operations or services, for
          example our staff engaged in the fulfilment of your order, processing
          of your payment, and provision of support services;
          {"\n"}
          2.7 Other services linked to your account, for example if you register
          or log in your account using your Google or Facebook credentials, we
          receive your name and email address to authenticate you and other
          profile information, as permitted by your Google, Facebook profile
          settings; Our current and future business partners and service
          providers based in the United States, members of European Union, UK
          and Australia who provide technical, payment, delivery services,
          advertising networks, analytics, market research, productivity tools,
          accounting software and search information services.
          {"\n"}
          2.8 We do not collect sensitive data or special category data about
          you. This includes details about your race, ethnic origin, politics,
          religion, trade union membership, genetics, biometrics, health, or
          sexual orientation.
          {"\n"}
          {"\n"}3. HOW WE USE INFORMATION WE COLLECT
          {"\n"}
          3.1 We only use your Personal Information where the law allows us to.
          We use your Personal Information only where: We need to perform the
          contract we have entered into (or are about to enter into) with you,
          including to operate our products or services, to provide customer
          support and personalised features, and to protect the safety and
          security of our Platform; It satisfies a legitimate interest which is
          not overridden by your fundamental rights or data protection
          interests, for example for research and development, and in order to
          protect our legal rights and interests You have given us consent to do
          so for a specific purpose, for example we may send you direct
          marketing materials or publish your information as part of our
          testimonials or customer stories to promote our products or services
          with your permission; or we need to comply with a legal or regulatory
          obligation.
          {"\n"}
          3.2 If you have given us consent to use your Personal Information for
          a specific purpose, you have the right to withdraw your consent any
          time by contacting us on email at eva@naturethings.co, but please note
          this will not affect any use of your Personal Information that has
          already been processed.
          {"\n"}
          3.3 We do not share your Personal Information with any company outside
          our group for marketing purposes, unless with your express specific
          consent to do so.
          {"\n"}
          3.4 For visitors to or users of our Platform who are located in the
          European Union, you expressly provide your consent our us to process
          your Personal Information in accordance with his Privacy Policy.
          {"\n"}
          {"\n"}4. HOW WE SHARE INFORMATION WE COLLECT
          {"\n"}
          4.1 We share information with third parties that help us operate,
          provide, support, improve, and market our products and services, for
          example third-party service providers who provide website and
          application development, data storage and backup, infrastructure,
          billing, payment processing, customer support, business analytics, and
          other services.
          {"\n"}
          4.2 Third-party service providers have access to your Personal
          Information only for the purpose of performing their services and in
          compliance with applicable laws and regulations. We undertake
          reasonable efforts to require these third-party service providers to
          maintain confidentiality and security of all Personal Information that
          they process on our behalf and to implement and maintain reasonable
          security measures to protect the confidentiality, integrity, and
          availability of your Personal Information.
          {"\n"}
          4.3 We take reasonable steps to confirm that all third-party service
          providers that we engage process Personal Information in the manner
          that provides at least the same level of protection as is provided
          under this Privacy Policy. Where any third-party provider is unable to
          satisfy our requirements, we will require them to notify us
          immediately and we will take reasonable steps to prevent or stop
          non-compliant processing.
          {"\n"}
          4.4 We may share Personal Information on an aggregated or
          de-identified basis with third parties for research and analysis,
          profiling, and similar purposes to help us improve our products and
          services.
          {"\n"}
          4.5 If you use any third-party software in connection with our
          products or services, for example any third-party software that our
          Platform integrates with, you might give the third-party software
          provider access to your account and information. Policies and
          procedures of third-party software providers are not controlled by us,
          and this policy does not cover how your information is collected or
          used by third-party software providers. We encourage you to review the
          privacy policies of third-party software providers before you use the
          third-party software.
          {"\n"}
          4.6 Our Platform may contain links to third-party websites over which
          we have no control. If you follow a link to any of these websites or
          submit information to them, your information will be governed by their
          policies. We encourage you to review the privacy policies of
          third-party websites before you submit information to them.
          {"\n"}
          4.7 We may share your information with government and law enforcement
          officials to comply with applicable laws or regulations, for example
          when we respond to claims, legal processes, law enforcement, or
          national security requests.
          {"\n"}
          4.8 If we are acquired by a third party as a result of a merger,
          acquisition, or business transfer, your Personal Information may be
          disclosed and/or transferred to a third party in connection with such
          a transaction. We will notify you if such a transaction takes place
          and inform you of any choices you may have regarding your information.
          {"\n"}
          {"\n"}5. HOW WE STORE AND SECURE INFORMATION WE COLLECT
          {"\n"}
          5.1 We use data hosting service providers based in Singapore and USA
          to host the information we collect.
          {"\n"}
          5.2 We have adopted the following measures to protect the security and
          integrity of your Personal Information: Information is encrypted end
          to end using TLS/SSL technology; Your account is password-protected
          with the requirement(s) that passwords must be at least 8 characters
          long or protected via OTP; Access to your Personal Information is
          restricted to personnel or service providers on a strictly
          need-to-know basis, who will only process your information on our
          instructions and who are subject to a duty of confidentiality; and our
          information collection, storage, and processing practices are reviewed
          regularly.
          {"\n"}
          5.3 We have put in place procedures to deal with any suspected privacy
          breach and will notify you and any applicable regulator of a breach
          where we are legally required to do so.
          {"\n"}
          5.4 While we implement safeguards designed to protect your
          information, please note that no transmission of information on the
          Internet is completely secure. We cannot guarantee that your
          information, during transmission through the Internet or while stored
          on our systems or processed by us, is absolutely safe and secure.
          {"\n"}
          5.5 We only retain Personal Information for so long as it is
          reasonably necessary to fulfil the purposes we collected it for,
          including for the purposes of satisfying any legal, accounting, or
          reporting requirements. After such time, we will delete or anonymise
          your information, or if this is not possible, we will securely store
          your information and isolate it from further use. We periodically
          review the basis and appropriateness of our data retention policy.
          {"\n"}
          {"\n"}6. HOW WE TRANSFER INFORMATION INTERNATIONALLY
          {"\n"}
          6.1 We collect information globally and primarily store that
          information in Singapore. We transfer, process, and store your
          information outside your country of residence where we or our service
          providers operate for the purpose of providing our products and
          services to you.
          {"\n"}
          6.2 Some of the countries in which our companies or service providers
          are located may not have the privacy and data protection laws that are
          equivalent to those in your country of residence. When we share
          information with these companies or service providers, we make use of
          contractual clauses, corporate rules, and other appropriate mechanisms
          to safeguard the transfer of information.
          {"\n"}
          {"\n"}7. YOUR RIGHTS
          {"\n"}
          7.1 You have the right to:
          {"\n"}
          (a) Be informed of what we do with your Personal Information.
          {"\n"}
          (b) Request a copy of Personal Information we hold about you.
          {"\n"}
          (c) Require us to correct any inaccuracy or error in any Personal
          Information we hold about you.
          {"\n"}
          (d) Request erasure of your Personal Information (note, however, that
          we may not always be able to comply with your request of erasure for
          record keeping purposes, to complete transactions, or to comply with
          our legal obligations).
          {"\n"}
          (e) Raise an objection to or restriction the processing by us of your
          Personal Information (including for marketing purposes) via listed
          communication channels.
          {"\n"}
          (f) Request to receive some of your Personal Information in a
          structured, commonly used, and machine readable format, and request
          that we transfer such information to another party and
          {"\n"}
          (g) Withdraw your consent at any time where we are relying on consent
          to process your Personal Information (although this will not affect
          the lawfulness of any processing carried out before you withdraw your
          consent).
          {"\n"}
          7.2 Our Platform enables you to update certain information about
          yourself, for example you may change your business or Personal
          Information by updating your user profile or changing your user
          settings.
          {"\n"}
          7.3 You may opt out of receiving marketing materials from us by using
          the unsubscribe link in our communications, by updating your
          preferences within your account on our Platform, or by contacting us.
          Please note, however, that even if you opt out from receiving
          marketing materials from us, you will continue to receive
          notifications or information from us that are necessary for the use of
          our products or services.
          {"\n"}
          7.4 As a security measure, we may need specific information from you
          to help us confirm your identity when processing your privacy requests
          or when you exercise your rights.
          {"\n"}
          7.5 Any request under paragraph 7.1 will normally be addressed free of
          charge. However, we may charge a reasonable administration fee if your
          request is clearly unfounded, repetitive, or excessive.
          {"\n"}
          7.6 We will respond to all legitimate requests within one (1) month.
          Occasionally, it may take us longer than a month if your request is
          particularly complex or if you have made a number of requests.
          {"\n"}
          {"\n"}8. CHANGES TO THIS PRIVACY POLICY
          {"\n"}
          8.1 We may amend this policy from time to time by posting the updated
          policy on our Platform. By continuing to use our Platform after the
          changes come into effect, you agree to be bound by the revised Privacy
          Policy.
          {"\n"}
          8.2 Contact us:
          {"\n"}
          (a) Please contact us at eva@naturethings.co or submit any written
          request to: All Nature Things Pte Ltd 1 North Bridge Road, #12-09,
          High Street Center, Singapore, 179094, Attn: Nalini Veeraghanta.
          {"\n"}
          (b) Please contact us in the first instance if you have any questions
          or concerns. If you have unresolved concerns, you have the right to
          file a complaint with a data protection authority in the country where
          you live or work or where you feel your rights have been infringed.
          {"\n"}
          {"\n"}9. COOKIES POLICY
          {"\n"}
          9.1 Cookies are small text files that are placed on your device by a
          web server when you access our Platform. We use cookies to identify
          your access and monitor usage and web traffic on our Platform to
          customise and improve our products and services.
          {"\n"}
          9.2 We use both, (a) persistent cookies and (b) session cookies. A
          persistent cookie stays in your browser and will be read by us when
          you return to our Site or a partner site that uses our services.
          Session cookies only last for as long as the session lasts (usually
          the current visit to a website or a browser session).
          {"\n"}
          9.3 We use the following types of cookies:
          {"\n"}
          (a) Strictly necessary cookies, which are cookies that are required
          for the operation of our site. They include, for example, cookies that
          enable you to log into secure areas of our website.
          {"\n"}
          (b) Analytical/performance cookies – these allow us to recognise and
          count the number of visitors and to see how visitors move around our
          Site when they are using it. This helps us to improve the way our site
          works, for example, by ensuring that users are easily finding what
          they are looking for.
          {"\n"}
          (c) Functionality cookies – these are used to recognise you when you
          return to our site. Targeting cookies – these cookies record your
          visit to our site, the pages you have visited, and the links you have
          followed.
          {"\n"}
          9.4 You can block cookies by activating the setting on your browser
          that allows you to refuse the use of all or some cookies. However, if
          you do so, you may not be able to access all or parts of our site.
          {"\n"}
          {"\n"}
          Updated March 8, 2022
        </Typography>

        <Typography fontFamily={"Inter"} variant="h6" mt={6}>
          {t("further_queries_note", { ns: "common" })}{" "}
          <Typography
            component="a"
            fontFamily={"Inter"}
            sx={{ textDecoration: "none" }}
            href="mailto:eva@naturethings.co"
            color="textPrimary"
            fontWeight="bold"
          >
            <ThinUnderlineText>eva@naturethings.co</ThinUnderlineText>
          </Typography>
        </Typography>
      </Container>
    </Layout>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
